export default {
  translations: {
	  standard_formatting: {
	    date: "{{value, date}}",
	    number: "{{value, number}}",
	    currency: "{{value, currency}}",
	    percentage: "{{value, percentage}}",
	    percentage_100: "{{value, percentage_100}}"
	  },
	  errors: {
	    error: 'Errore',
	    'NO_CREDITS': "Nan hai crediti sufficenti",
	    'GENERIC_ERROR': "Servizio temporaneamente non disponibile",
	    'SERVICE_ERROR': "Servizio temporaneamente non disponibile",
	    'INVALID_XLS': "L'excel caricato non è valido"
	  },
	  validations: {
	    "can't be blank": "Questo campo è obbligatorio",
	    "is not a valid email": "Non è una email valida",
	    "is not a number": "Il valore inserito non è un numero",
	    "minlength": "La lunghezza minima è di {{minimum}} caratteri",
	    "greaterThan": "Il valore deve essere maggiore di {{minimum}}",
	    "must be an integer": "Il numero deve essere un intero"
	  },
    country_iso_code:{
      AF: 'Afghanistan',
      AL: 'Albania',
      DZ: 'Algeria',
      AD: 'Andorra',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antartide',
      AG: 'Antigua e Barbuda',
      SA: 'Arabia Saudita',
      AR: 'Argentina',
      AM: 'Armenia',
      AW: 'Aruba',
      AU: 'Australia',
      AT: 'Austria',
      AZ: 'Azerbaigian',
      BS: 'Bahamas',
      BH: 'Bahrein',
      BD: 'Bangladesh',
      BB: 'Barbados',
      BE: 'Belgio',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermuda',
      BT: 'Bhutan',
      BY: 'Bielorussia',
      MM: 'Birmania',
      BO: 'Bolivia',
      BA: 'Bosnia ed Erzegovina',
      BW: 'Botswana',
      BR: 'Brasile',
      BN: 'Brunei',
      BG: 'Bulgaria',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Cambogia',
      CM: 'Camerun',
      CA: 'Canada',
      CV: 'Capo Verde',
      TD: 'Ciad',
      CL: 'Cile',
      CN: 'Cina',
      CY: 'Cipro',
      VA: 'Citt',
      CO: 'Colombia',
      KM: 'Comore',
      KP: 'Corea del Nord',
      KR: 'Corea del Sud',
      CI: "Costa d'Avorio",
      CR: 'Costa Rica',
      HR: 'Croazia',
      CU: 'Cuba',
      CW: 'Cura',
      DK: 'Danimarca',
      DM: 'Dominica',
      EC: 'Ecuador',
      EG: 'Egitto',
      SV: 'El Salvador',
      AE: 'Emirati Arabi Uniti',
      ER: 'Eritrea',
      EE: 'Estonia',
      ET: 'Etiopia',
      FJ: 'Figi',
      PH: 'Filippine',
      FI: 'Finlandia',
      FR: 'Francia',
      GA: 'Gabon',
      GM: 'Gambia',
      GE: 'Georgia',
      GS: 'Georgia del Sud e isole Sandwich meridionali',
      DE: 'Germania',
      GH: 'Ghana',
      JM: 'Giamaica',
      JP: 'Giappone',
      GI: 'Gibilterra',
      DJ: 'Gibuti',
      JO: 'Giordania',
      GR: 'Grecia',
      GD: 'Grenada',
      GL: 'Groenlandia',
      GP: 'Guadalupa',
      GU: 'Guam',
      GT: 'Guatemala',
      GG: 'Guernsey',
      GN: 'Guinea',
      GW: 'Guinea-Bissau',
      GQ: 'Guinea Equatoriale',
      GY: 'Guyana',
      GF: 'Guyana francese',
      HT: 'Haiti',
      HN: 'Honduras',
      HK: 'Hong Kong',
      IN: 'India',
      ID: 'Indonesia',
      IR: 'Iran',
      IQ: 'Iraq',
      IE: 'Irlanda',
      IS: 'Islanda',
      BV: 'Isola Bouvet',
      IM: 'Isola di Man',
      CX: 'Isola di Natale',
      NF: 'Isola Norfolk',
      AX: 'Isole ',
      BQ: 'Isole BES',
      KY: 'Isole Cayman',
      CC: 'Isole Cocos (Keeling)',
      CK: 'Isole Cook',
      FO: 'F',
      FK: 'Isole Falkland',
      HM: 'Isole Heard e McDonald',
      MP: 'Isole Marianne Settentrionali',
      MH: 'Isole Marshall',
      UM: 'Isole minori esterne degli Stati Uniti',
      PN: 'Isole Pitcairn',
      SB: 'Isole Salomone',
      VG: 'Isole Vergini britanniche',
      VI: 'Isole Vergini americane',
      IL: 'Israele',
      IT: 'Italia',
      JE: 'Jersey',
      KZ: 'Kazakistan',
      KE: 'Kenya',
      KG: 'Kirghizistan',
      KI: 'Kiribati',
      KW: 'Kuwait',
      LA: 'Laos',
      LS: 'Lesotho',
      LV: 'Lettonia',
      LB: 'Libano',
      LR: 'Liberia',
      LY: 'Libia',
      LI: 'Liechtenstein',
      LT: 'Lituania',
      LU: 'Lussemburgo',
      MO: 'Macao',
      MK: 'Macedonia',
      MG: 'Madagascar',
      MW: 'Malawi',
      MY: 'Malesia',
      MV: 'Maldive',
      ML: 'Mali',
      MT: 'Malta',
      MA: 'Marocco',
      MQ: 'Martinica',
      MR: 'Mauritania',
      MU: 'Mauritius',
      YT: 'Mayotte',
      MX: 'Messico',
      FM: 'Micronesia',
      MD: 'Moldavia',
      MN: 'Mongolia',
      ME: 'Montenegro',
      MS: 'Montserrat',
      MZ: 'Mozambico',
      NA: 'Namibia',
      NR: 'Nauru',
      NP: 'Nepal',
      NI: 'Nicaragua',
      NE: 'Niger',
      NG: 'Nigeria',
      NU: 'Niue',
      NO: 'Norvegia',
      NC: 'Nuova Caledonia',
      NZ: 'Nuova Zelanda',
      OM: 'Oman',
      NL: 'Paesi Bassi',
      PK: 'Pakistan',
      PW: 'Palau',
      PS: 'Palestina',
      PA: 'Panam',
      PG: 'Papua Nuova Guinea',
      PY: 'Paraguay',
      PE: 'Per',
      PF: 'Polinesia Francese',
      PL: 'Polonia',
      PR: 'Porto Rico',
      PT: 'Portogallo',
      MC: 'Monaco',
      QA: 'Qatar',
      GB: 'Regno Unito',
      CD: 'RD del Congo',
      CZ: 'Rep. Ceca',
      CF: 'Rep. Centrafricana',
      CG: 'Rep. del Congo',
      DO: 'Rep. Dominicana',
      RE: 'Riunione',
      RO: 'Romania',
      RW: 'Ruanda',
      RU: 'Russia',
      EH: 'Sahara Occidentale',
      KN: 'Saint Kitts e Nevis',
      LC: 'Santa Lucia',
      SH: "Sant'Elena, Ascensione e Tristan da Cunha",
      VC: 'Saint Vincent e Grenadine',
      BL: 'Saint-Barth',
      MF: 'Saint-Martin',
      PM: 'Saint-Pierre e Miquelon',
      WS: 'Samoa',
      AS: 'Samoa Americane',
      SM: 'San Marino',
      ST: 'São Tomé e Príncipe',
      SN: 'Senegal',
      RS: 'Serbia',
      SC: 'Seychelles',
      SL: 'Sierra Leone',
      SG: 'Singapore',
      SX: 'Sint Maarten',
      SY: 'Siria',
      SK: 'Slovacchia',
      SI: 'Slovenia',
      SO: 'Somalia',
      ES: 'Spagna',
      LK: 'Sri Lanka',
      US: 'Stati Uniti',
      ZA: 'Sudafrica',
      SD: 'Sudan',
      SS: 'Sudan del Sud',
      SR: 'Suriname',
      SJ: 'Svalbard e Jan Mayen',
      SE: 'Svezia',
      CH: 'Svizzera',
      SZ: 'Swaziland',
      TW: 'Taiwan',
      TJ: 'Tagikistan',
      TZ: 'Tanzania',
      TF: 'Terre australi e antartiche francesi',
      IO: "Territorio britannico dell'oceano Indiano",
      TH: 'Thailandia',
      TL: 'Timor Est',
      TG: 'Togo',
      TK: 'Tokelau',
      TO: 'Tonga',
      TT: 'Trinidad e Tobago',
      TN: 'Tunisia',
      TR: 'Turchia',
      TM: 'Turkmenistan',
      TC: 'Turks e Caicos',
      TV: 'Tuvalu',
      UA: 'Ucraina',
      UG: 'Uganda',
      HU: 'Ungheria',
      UY: 'Uruguay',
      UZ: 'Uzbekistan',
      VU: 'Vanuatu',
      VE: 'Venezuela',
      VN: 'Vietnam',
      WF: 'Wallis e Futuna',
      YE: 'Yemen',
      ZM: 'Zambia',
      ZW: 'Zimbabwe',
      XK: 'Kosovo',
      "": "-"
    },
	  forms: {
	    select: "Seleziona",
	    submit: "Salva",
	    cancel: "Annulla"
	  },
	  add_company: {
	    search: "Cerca"
	  },
	  menu: {
	    dashboard: "Dashboard",
	    prospect: 'Prospect',
	    companies: 'Companies',
	    products: "products",
	    groups: 'Groups',
	    credits: "Credits",
	    credits_logs: "Credits logs"
	  },
	  login: {
	    welcome: "Benvenuto",
	    sign_in_to_continue: "Accedi per continuare",
	    email: "e-mail",
	    password: "Password",
	    sign_in: 'Accedi',
	    logout: "Disconnetti"
	  },
	  invoices:{
	    document_id: 'ID documento',
	    amount: 'Importo totale fatture aperte',
	    leftover: 'Residuo netto',
	    issue_date: 'Data emmissione',
	    due_date: 'Scadenza',
	    close_date: 'Data chiusura',
	    accounting_year: 'Anno'
	  },
	  invoices_info: {
	    leftover: 'Esposizione',
	    leftover_exp: 'Scaduto',
	    leftover_neg: 'Totale partite negative',
	    leftover_net: 'Esposizione netta',
	    leftover_total: 'Esposizione totale',
	    invoices_total_vat: 'Fatturato totale con iva',
	    invoices_365_vat: 'Fatturato 365 giorni con iva',
	    invoices_total_vat_1: 'Fatturato precedente con iva',
	  },
	  companies: {
	    actions: {
		    speek_flash: "Crea report flash",
		    speek_extended: "Crea report extended",
		    creditsafe: "Crea report europa",
		    creditsafe_world: "Crea report extra europa",
		    excel: "Carica da excel",
		    download_template: "Scarica template",
		    download_xls: "Scarica in xls",
		    analysis: "Report",
		    visura_pdf: 'Acquista visura pdf',
		    visura_storica_pdf: 'Acquista visura storica pdf',
        bilancio_pdf: 'Bilancio pdf NON consolidato',
        bilancio_pdf_consolidato: 'Bilancio pdf CONSOLIDATO'
	    },
	    sections:{
		    main_info: "Dati azienda",
		    download_report: "Visure",
		    view_report: "Report",
		    products: "Prodotti disponibili",
		    invoices: "Dati fatture"
	    },
	    main_info: {
		    name: "Nome",
		    identification_number: "N identificazione",
		    customer_id: "Customer id",
		    address: "Indirizzo", 
		    city: "Città",
		    fiscal_code: "Codice fiscale",
		    piva: "Piva",
			euvat: "Euvat",
		    postal_code: "Codice postale",
		    country_description_en: "Nazione",
		    legal_form_description_en: "Forma legale",
		    registration_date: "Data registrazione",
		    status_description_en: "Stato",
		    ateco_sector_code: "Codice ateco",
		    country_iso_code: 'Country',
		    ateco_sector_description_en: "Descrizione Ateco",
		    email: "e-mail",
		    website:"Sito web",
		    pec: "PEC",
		    more: "MORE",
		    operating_revenue_or_turnover: "Operating revenue",
		    credit_limit: "Credit limit",
		    leftover: 'Esposizione',
		    leftover_exp: 'Scaduto',
		    dso: 'DSO',
		    issuing_companies_names: 'Società'
	    },
	    no_search_results: "La ricerca non ha prodotto risultati"
	  },
	  filter_companies: {
	    form_title: "Filtra sociaetà",
	    name: "Nome",
	    more: "MORE",
	    credit_limit: "Credit limit",
	    operating_revenue_or_turnover: "Operating revenue",
	    identification_number: "N identificazione",
	    address: "Indirizzo", 
	    city: "Città",
	    submit: "Cerca",
	    reset: "reset",
	    cancel: "Annulla",
	    country_iso_code: 'Country',
	    leftover: 'Esposizione',
	    leftover_exp: 'Scaduto',
	    dso: 'DSO',
	    customer_id: "Customer id",
	    issuing_companies_names: 'Società'
	  },
	  reports: {
	    sections: {
		    negativity: 'Negatività',
		    balances: "Bilanci",
		    assessment: "Valutazione more",
		    board_of_directors: "Board",
		    shareholders: "Soci"
	    },
	    actions:{
		    update: 'Aggiorna'
	    },
	    updated_at: "Aggiornato il",
	    created_at: "Creato il",
	    updates: 'Aggiornamenti disponibili',
	    update_types: {
		    'STATUS': 'Stato attività',
		    'BLACK_RECORDS': 'Negatività',
		    'CLOSING_DATE': 'Ultimo bilancio',
		    'INFOCAMERE_SOCI': "Soci",
		    'CREDITSAFE': 'Aggiornamento generico',
		    'CREDITSAFE_GENERIC': 'Aggiornamento generico'
	    }
	  },
	  products: {
	    name: "Nome",
	    price: "Numero di crediti",
	    edit_action: "Modifica",
	    form_title: "Prodotto",
	    'SPEEK_FLASH': "Speek flash",
	    'SPEEK_EXTENDED': "Speek extended",
	    'CREDITSAFE': "Europa",
	    'CREDITSAFE_WORLD': "Extra europa",
	    'VISURA_PDF': 'Visura pdf',
	    'VISURA_STORICA_PDF': 'Visura storica pdf',
      'BILANCIO_PDF': 'Bilancio pdf',
	    'EXCEL': "excel",
	    submit: "Salva",
	    title: "Titolo",
	    cancel: "Annulla",
	  },
	  groups: {
	    name: "Nome",
	    credit_id: "Credit box",
	    form_title: "Gruppo",
	    submit: "Salva",
	    cancel: "Annulla"
	  },
	  users: {
	    form_title: "Utente",
	    name: "Nome",
	    surname: "Cognome",
	    email: "e-mail",
	    password: "Password",
	    submit: "Salva",
	    cancel: "Annulla"
	  },
	  credits: {
	    form_title: "Crediti",
	    name: "Nome",
	    current_amount: "Crediti attuali",
	    charge: "Ricarica",
	    amount: "N° crediti",
	    submit: "Salva",
	    cancel: "Annulla"
	  },
	  credits_logs: {
	    title: "Movimento crediti",
	    amount: "N° crediti",
	    created_at: "Data",
	    current_balance_message: "Tu hai <strong>{{count}}</strong> crediti",
	    description: "Descrizione",
	    charge: "Ricarica",
	    description_row: "Acquistato {{product}} per {{company}}",
	    description_refund_row: "Rimborso {{product}} per {{company}}",
	    actions: {download_xls: "Scarica in xls"}
	    
	  },
	  shareholders: {
	    name: "Nome",
	    fiscal_code: "Codice fiscale",
	    semaphore: "More semaphore",
	    percentage_share: "percentuale possesso"
	  },
	  board_of_directors: {
	    name: "Nome",
	    surname: "Surname",
	    charges: "Cariche"
	  },
	  accounts: {
	    
	    balance_sheet: "Stato patrimoniale",
	    income_statement: "Conto economico",
	    closing_date: "Data chiusura",
	    is_consolidated: "Consolidato d'esercizio",
	    number_of_months: 'Mesi',
	    total_assets: "Totale attività",
	    fixed_assets: "Attività immobilizzate",
	    intangible_fixed_assets: "Imm.ni immateriali nette",
	    tangible_fixed_assets: "Imm.ni materiali nette",
	    other_fixed_assets: "Imm.ni finanziarie nette",
	    current_assets: "Disponibilità",
	    stocks: "Scorte attive",
	    debtors: "Crediti verso clienti",
	    other_revenues: "Altri ricavi",
	    other_current_assets: "Altri crediti + attività finanziarie non imm.te",
	    cash_cash_equivalent: "Liquidità",
	    shareholders_funds: "Patrimonio netto",
	    capital: "Capitale sociale",
	    other_shareholders_funds: "Riserve",
	    total_liabilities: "Passività",
	    non_current_liabilities: "Passività consolidata",
	    long_term_debt: "Debiti finanziari a medio/lungo termine",
	    other_non_current_liabilities: "Altri debiti a lungo termine",
	    provisions: "Provisions",
	    current_liabilities: "Esigibilità",
	    loans: "Debiti finanziari a breve termine",
	    creditors: "Debiti verso fornitori",
	    other_current_liabilities: "Altri debiti a breve",
	    total_shareholders_funds_liabilities: "Patrimonio netto + Passività",
	    net_debt: "Posizione finanziaria netta",
	    working_capital: "Working capital",
	    net_current_assets: "Attività correnti nette",
	    enterprise_value: "Enterprise value",
	    number_of_employees: "Dipendenti",
	    operating_revenue_or_turnover: "Valore totale della produzione",
	    sales: "Ricavi delle vendite",
	    other_income: "Altri ricavi e proventi (inclusa Variazione dei prodotti e Prodotti per uso interno)",
	    total_costs: "Costo della produzione ottenuta",
	    service_costs: "Costi per servizi e altri costi",
	    costs_of_good_sold: "Costo del venduto",
	    gross_profit: "Risultato lordo industriale",
	    gross_profit_2: "Risultato Lordo Industriale/Fatturato",
	    other_operating_expenses: "Altri costi operativi",
	    ebit: "Margine Operativo Netto (MON)",
	    financial_revenue: "Proventi finanziari",
	    financial_expenses: "Oneri finanziari",
	    financial_pl: "Gestione finanziaria",
	    pl_before_tax: "Utile/Perdita ante imposte e ante partite straordinarie",
	    pl_before_tax_extraordinary_and_other_pl: "Utile/Perdita ante imposte e ante partite straordinarie",
	    taxation: "Imposte sul reddito",
	    pl_after_tax: "Utile/Perdita post imposte e ante partite straordinarie",
	    extraordinary_and_other_revenue: "Ricavi straordinari",
	    extraordinary_and_other_expenses: "Costi straordinarie",
	    extraordinary_and_other_pl: "Partite straordinarie",
	    net_profit: "Utile/Perdita netta prima delle imposte",
	    pl_for_period: "Utile/Perdita del periodo",
	    export_turn_over: "Export Turnover",
	    material_costs: "Costo d'acquisto materie e Variazioni materie",
	    costs_of_employees: "Salari, stipendi e oneri relativi",
	    depreciation: "Ammortamenti e svalutazione",
	    interest_paid: "Interessi passivi",
	    research_development_expenses: "Spese di ricerca e sviluppo",
	    cash_flow: "Flusso di cassa",
	    added_value: "Valore aggiunto",
	    ebitda: "EBITDA",
	    treasury_shares: "Riserva azioni proprie",
	    net_financial_position: "POSIZIONE FINANZIARIA NETTA (k€)",
	    short_term_debt: "Debiti finanziari a breve termine",
	    long_term_debt: "Debiti finanziari a lungo termine",
	    cash_cash_equivalent: "cash_cash_equivalent"
	  },
	  assessments: {
	    
	    closing_date: "Data chiusura",
	    confidence: {title: "Confidence", hint: "Confidence"},
	    solvency_ratios: "Indicatori di solvibilità",
	    leverage_ratio: {title: "Financial leverage", hint: "(Debiti financiari a medio / lungo termine+debiti finanziari a breve termine) / Patrimonio Netto"},
	    total_asset_total_liabilities_ratio: {title:  "Totale attività/Totale debiti", hint: "Totale attività / Totale passività"},
	    liquidity_ratios: "Indicatori di liquidità",
	    profitability_ratios:"Indicatori di redditività",
	    roi_ratio: {title:"Return on investement ROI", hint: "MON / Totale attività"},
	    roe_ratio: {title:"Return on equity ROE", hint: "Utile(Perdita) / Patrimonio netto"},
	    asset_turnover_ratio: {title:"Ricavi vendite/Totale attivo", hint: "Ricavi vendite / Totale attivo"},
	    mol: {title:"MOL/Ricavi delle vendite", hint: "MOL/Fatturato"},
	    interest_coverage_ratios: "Indicatori di copertura interessi",
	    current_ratio: {title:"Current ratio", hint: "Attività correnti / Passività correnti"},
	    quick_ratio: {title:"Quick ratio", hint: "(Attività correnti - scorte di magazzino) / Passività correnti"},
	    cash_cycle_ratio: {title:"Qualità del Ciclo Monetario", hint: "Qualità del Ciclo Monetario"},
	    ebitda_sales_ratio: {title:"MOL/Ricavi dalle vendite", hint: "MOL/Fatturato"},
	    ebit_interest_coverage_ratio: {title:"Copertura interessi col MON", hint: "MON / Interessi passivi"},
	    ebitda_interest_coverage_ratio: {title:"Copertura interessi col MOL", hint: "MOL / Interessi passivi"}
	  }
  }
}
